import { Injectable } from '@angular/core';

import { RepositoryService } from '@_services/api/repository.service';
import { GeneratedCompanyCommunicationFileApiService } from './company-communication-file-api-generated.service';

@Injectable({
  providedIn: 'root'
})
export class CompanyCommunicationFileApiService extends GeneratedCompanyCommunicationFileApiService {
  constructor(repo: RepositoryService) {
    super(repo);
  }
}
